import styled from 'styled-components'


const ButtonSimpleStyle = styled.button.attrs(props => ({ className: props.className }))`
    padding: var(--sp2x) var(--sp3x);
    font-size: 14px;
    border-radius: var(--sp1-5x);
    -webkit-appearance: none;
    position: relative;
    background-color: var(--purple);
    color: var(--white);
    transition: var(--trTime) ease-out;
    font-family: PopSemi;
    font-weight: unset;
    border:none;
    white-space: nowrap;
    display: flex;
    align-items: center;

    svg {
        width: 20px;
        height: auto;
        margin-right: 8px;
    }

    &.align-start {
        align-self: flex-start;
    }
    &.align-end {
        align-self: flex-end;
    }

    &:hover {
        background-color: #914EFF;
    }

    &.full-width {
        width: 100% !important;
    }

    &.white {
        background-color: var(--white);
        color: var(--black);
        border:2px solid var(--lightGrey);
        
        &.purple {
            color: var(--purple);

            &.bordered {
                border-color:var(--purple);
            }
        }

        &:hover {
            border-color:var(--purple);
        }
    }

    &.red {
        background-color: var(--red);

        &:hover {
            background-color:#FF6174;
        }
    }

    &.green {
        background-color: var(--green);

        &:hover {
            background-color:var(--green);
        }
    }

    &.orange {
        background-color: var(--orange);
        text-transform: uppercase;
        color: var(--white);
        
        &:hover {
            background-color:#FF9C4E;
        }
    }

    &.grey {
        color: var(--black);
        background-color: var(--lightGrey);

        &:hover {
            background-color:#E8E8E8;
        }
    }

    &.fit {
        height:fit-content;
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.MobileSize}){
        padding: var(--spSize) var(--sp2x);

        &.timer {
            padding:var(--sp2x);
        }
    }
`
export default ButtonSimpleStyle
